export default __webpack_public_path__ + "static/media/Smuggler's Den Teleport.3ee7c993.PNG";